var _style, _ellipse, _path, _rect, _rect2, _polygon, _ellipse2, _path2, _path3, _path4, _ellipse3, _ellipse4, _ellipse5, _path5, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path6, _ellipse6, _ellipse7, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect17, _path15, _path16, _path17, _path18, _path19, _path20, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _path21, _rect35, _rect36, _rect37, _rect38, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _rect39, _rect40, _rect41, _path34, _path35, _polygon2, _path36, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _ellipse8, _path37, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _path38, _path39, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _g, _g2, _path40, _path41, _path42, _rect82, _path43;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKyloRenHilt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 200",
    style: {
      enableBackground: "new 0 0 55 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0krh{fill:#564318;}\r\n\t.st1krh{fill:#8C888A;}\r\n\t.st2krh{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st3krh{fill:#191816;}\r\n\t.st4krh{fill:#3A3135;}\r\n\t.st5krh{fill:#715621;}\r\n\t.st6krh{fill:#333333;}\r\n\t.st7krh{fill:#931916;}\r\n\t.st8krh{fill:#725720;}\r\n\t.st9krh{fill:#5A5958;}\r\n\t.st10krh{fill:#4A4848;}\r\n\t.st11krh{fill:#3F363A;}\r\n\t.st12krh{fill:#931914;}\r\n\t.st13krh{fill:#4A4145;}\r\n\t.st14krh{fill:#931918;}\r\n\t.st15krh{fill:#828282;}\r\n\t.st16krh{fill:#221F1F;}\r\n\t.st17krh{fill:#3A3A3A;}\r\n\t.st18krh{fill:#4C4C48;}\r\n\t.st19krh{fill:#717070;}\r\n\t.st20krh{fill:#1E1E1E;}\r\n\t.st21krh{fill:#353434;}\r\n\t.st22krh{fill:#340D1F;}\r\n\t.st23krh{fill:#5C5C5C;}\r\n\t.st24krh{fill:#47333D;}\r\n\t.st25krh{fill:#2D252A;}\r\n\t.st26krh{fill:#2D2C2C;}\r\n\t.st27krh{fill:#1B172B;}\r\n\t.st28krh{fill:#381026;}\r\n\t.st29krh{fill:#A0A09F;}\r\n\t.st30krh{fill:#93191A;}\r\n\t.st31krh{fill:#929292;}\r\n\t.st32krh{fill:#161616;}\r\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0krh",
    cx: 28.6,
    cy: 189.1,
    rx: 8,
    ry: 5.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1krh",
    d: "M33.8,189.8c-1.2,0.8-3.2,1.7-5.6,1.7c-2.1-0.1-3.8-0.9-5-1.7c0-4.1,0-8.2,0-12.4h10.6V189.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 182.8,
    className: "st2krh",
    width: 1.1,
    height: 3.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7,
    y: 184.9,
    className: "st2krh",
    width: 0.8,
    height: 3.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2krh",
    points: "26.2,188.7 25.7,187.5 26.4,186.5 27,187.7 "
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2krh",
    cx: 29.1,
    cy: 182.8,
    rx: 1.1,
    ry: 1.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3krh",
    d: "M35,142c-2,0.5-4.2,0.9-6.7,1c-2.7,0.1-5.1-0.2-7.1-0.6c0,11.7,0.1,23.5,0.1,35.2c1.3,1,3.7,2.7,7,2.6 c3.4-0.1,5.9-2.1,7.1-3.3C35.2,165.3,35.1,153.7,35,142z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4krh",
    d: "M20.4,189.9c1.1,1.3,4.1,4.3,8.3,4.2c3.8-0.1,6.6-2.9,7.7-4.2c0,1.7,0,3.4,0,5.1c-1,1.2-4.4,5.1-9.2,4.4 c-3.3-0.5-5.7-3.1-6.8-4.4C20.5,193.3,20.4,191.6,20.4,189.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0krh",
    d: "M28.2,179.4L28.2,179.4c-1.1,0-1.9-0.9-1.9-1.9v-36.6c0-1.1,0.9-1.9,1.9-1.9h0c1.1,0,1.9,0.9,1.9,1.9v36.6 C30.1,178.5,29.3,179.4,28.2,179.4z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st5krh",
    cx: 28.3,
    cy: 176.3,
    rx: 1.2,
    ry: 2
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6krh",
    cx: 28.2,
    cy: 176.3,
    rx: 0.3,
    ry: 0.6
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7krh",
    cx: 28.9,
    cy: 198.7,
    rx: 3.6,
    ry: 1.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8krh",
    d: "M28.2,171.2L28.2,171.2c-0.4,0-0.7-0.3-0.7-0.7v-23.1c0-0.4,0.3-0.7,0.7-0.7h0c0.4,0,0.7,0.3,0.7,0.7v23.1 C28.9,170.9,28.6,171.2,28.2,171.2z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 151.3,
    className: "st9krh",
    width: 1.5,
    height: 20
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 165.5,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 166.2,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 167,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 167.9,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 168.7,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 169.4,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 150.8,
    className: "st9krh",
    width: 1.5,
    height: 20
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 165,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 165.8,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 166.6,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 167.4,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 168.3,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 169,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4krh",
    d: "M35.4,141.8c-1.8,0.9-4.3,1.7-7.2,1.8c-3.1,0.1-5.6-0.6-7.5-1.4c0-22.7,0-45.3,0-68h14.8 C35.4,96.7,35.4,119.3,35.4,141.8z"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st5krh",
    cx: 28.2,
    cy: 142.5,
    rx: 1.2,
    ry: 2
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6krh",
    cx: 28.2,
    cy: 142.5,
    rx: 0.3,
    ry: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4krh",
    d: "M21.4,150c0-1,0-1.9,0-2.9c0-0.1-0.2-0.3-0.5-0.3c-0.2,0-0.4,0.2-0.4,0.3c-0.3,1.4-0.7,2.8-1,4.1 c-0.2,10.6-0.3,21.2-0.5,31.8c-0.2,2.5-0.4,5.1-0.7,7.6c-0.1,0.8,0,1.6,0.2,2c0.2,0.3,0.4,0.3,0.5,0.3c0.5,0.1,0.9,0.2,1.4,0.3 c0-1.1-0.1-2.3-0.1-3.4c0.3,0.3,0.6,0.7,1,1c0.4,0.3,0.7,0.7,1.1,0.9c-0.3-1.7-0.6-3.5-0.8-5.2c0-2.8,0-5.6,0-8.4 c-0.2-0.4-0.4-0.8-0.6-1.2c-0.1-8.7-0.2-17.4-0.3-26.1C21,150.6,21.2,150.3,21.4,150z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4krh",
    d: "M36.5,193.5c0.2,0,0.8,0.1,1.4-0.6c0.3-0.4,0.5-0.8,0.6-1.1c-0.4-3.6-0.8-7.3-1.2-10.9 c-0.1-10-0.3-20.1-0.4-30.1c-0.3-1.3-0.6-2.5-0.9-3.8c0-0.2-0.1-0.3-0.2-0.3c-0.1,0-0.2,0.1-0.3,0.3c-0.1,13-0.2,26-0.3,39 c0.2,0.4,0.5,1,0.7,1.7c0.2,0.5,0.3,1,0.4,1.4C36.4,190.5,36.4,192,36.5,193.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4krh",
    d: "M33.2,150.8c-0.5-1.5-1.4-2-2-1.5c-0.4,0.4-0.5,1.3-0.5,1.5c0.3,14.4,0.6,28.8,0.8,43.2 c-0.2,0.9-0.3,1.8-0.5,2.8c0,0.1,0,0.7,0.2,1.2c0.3,0.5,0.7,0.5,1.1,0.1c1.4-1,2.1-1.8,2-2.4c0-0.2-0.1-0.3-0.2-0.4 C33.9,180.5,33.5,165.6,33.2,150.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4krh",
    d: "M23.3,149.9c0.2-0.2,0.6-0.4,1.1-0.5c0.5-0.1,0.9,0.1,1.2,0.2c-0.1,14.8-0.2,29.6-0.3,44.4 c0.1,0.7,0.1,1.5,0.2,2.2c0.3,0.6,0.3,1.6,0,2c-0.2,0.3-0.6,0.3-0.9-0.1c-0.3-0.1-0.5-0.3-0.6-0.4c-0.5-0.6-0.6-2-0.4-3.3 C23.5,179.6,23.4,164.8,23.3,149.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11krh",
    d: "M36.2,185.9c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.2-0.1,0.2-0.3c0-11.9,0-23.8,0-35.6c-0.1-0.1-0.2-0.3-0.2-0.4 C36.3,161.8,36.2,173.9,36.2,185.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11krh",
    d: "M31.2,152.3c0.1,0,0.4,0,0.6,0.4c0.4,0.6,0.3,1.5,0.3,1.6c0.1,12.9,0.2,25.7,0.2,38.6c-0.2-0.3-0.5-0.6-0.7-1 C31.5,178.6,31.4,165.5,31.2,152.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st11krh",
    d: "M24.8,152.3c-0.1,0-0.4,0.2-0.6,0.6c-0.4,0.8-0.2,1.8-0.2,1.9c0,13.4,0,26.8,0.1,40.2c0.3-0.1,0.6-0.3,0.9-0.4 C24.9,180.5,24.9,166.4,24.8,152.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st11krh",
    d: "M20.2,149.8c-0.1,0.3-0.2,0.6-0.2,0.9c0,12.8,0.1,25.6,0.1,38.4c0.2-0.2,0.3-0.5,0.5-0.7 C20.4,175.5,20.3,162.6,20.2,149.8z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9,
    y: 72.5,
    className: "st4krh",
    width: 14.3,
    height: 2.4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st12krh",
    d: "M23.2,180.1c0-0.5,0-1,0-1.4c-0.2-0.2-0.4-0.5-0.6-0.9c-0.2-0.4-0.4-0.9-0.5-1.2c0-0.9-0.1-2.1,0.1-3.5 c0.2-1.6,0.4-2.9,0.7-3.8c0.1-0.5,0.1-1,0.2-1.7c0-0.8,0-1.5,0-2c-0.4-0.1-0.8-0.2-1.3-0.3c0.1,0.7,0.1,1.8,0,3.1 c-0.2,1.5-0.5,2.6-0.7,3.2c0,1.8,0,3.7,0.1,5.5c0.1,0.4,0.4,1.8,1.2,2.5C22.6,180,22.9,180.1,23.2,180.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st7krh",
    d: "M22,162.2c0.4-0.3,0.8-0.6,1.2-0.9c0-3.6,0-7.3,0-10.9c0.3-1,0.6-2.1,0.9-3.1c0.1-5.6,0.1-11.1,0.2-16.7 c0,0-0.3-0.6-0.7-0.5c-0.3,0-0.5,0.5-0.5,0.5c-0.2,6.4-0.5,12.7-0.7,19.1C22.3,153.8,22.2,158,22,162.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st13krh",
    d: "M32.5,143c-0.3,0.1-0.6,0.1-0.9,0.2c0-23,0-46,0-69h0.9C32.4,97.1,32.4,120,32.5,143z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st13krh",
    d: "M35.4,141.8c-0.1,0.1-0.3,0.1-0.4,0.2c0-15.8,0-31.7-0.1-47.5c0.2,0,0.3,0,0.5,0 C35.4,110.3,35.4,126.1,35.4,141.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st13krh",
    d: "M27.6,139c-0.2,0-0.4,0-0.6,0c0-14.8,0-29.5,0-44.3c0.2,0,0.4,0,0.6,0C27.6,109.5,27.6,124.2,27.6,139z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st13krh",
    d: "M21.4,142.4c-0.2-0.1-0.5-0.2-0.7-0.3c0-14.4,0-28.8,0-43.2c0.2,0,0.5,0,0.7,0C21.4,113.5,21.4,128,21.4,142.4 z"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 74.2,
    className: "st9krh",
    width: 1.5,
    height: 20.6
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 89,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 89.7,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 90.5,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 91.4,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 92.2,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 92.9,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2,
    y: 74.2,
    className: "st9krh",
    width: 1.5,
    height: 20.4
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2,
    y: 88.8,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2,
    y: 89.6,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2,
    y: 90.3,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2,
    y: 91.2,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2,
    y: 92,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2,
    y: 92.8,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 74.2,
    className: "st9krh",
    width: 1.5,
    height: 20.4
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 88.8,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 89.6,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st14krh",
    d: "M24.5,127.3c0.2-5.8,0.2-12,0.1-18.7c-0.1-5-0.3-9.8-0.5-14.3c-0.3,0-0.7-0.1-1-0.1c0.2,5.2,0.3,10.6,0.4,16.2 c0.1,6.2,0.1,12.1,0,17.7C23.7,127.9,24.1,127.6,24.5,127.3z"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 90.3,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 91.2,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 92,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 92.8,
    className: "st10krh",
    width: 1.5,
    height: 0.4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st15krh",
    d: "M24.8,131c0-1.7,0-3.4,0-5c-0.3,0.5-0.6,0.9-0.9,1.4c-0.3-0.3-0.6-0.6-1-0.9c0,1.5,0,3,0,4.5 c0.3-0.2,0.6-0.5,0.9-0.7C24.1,130.5,24.4,130.8,24.8,131z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st15krh",
    d: "M24.5,95.8c0-1.7,0-3.4,0-5c-0.3,0.5-0.6,0.9-0.9,1.4c-0.3-0.3-0.6-0.6-1-0.9c0,1.5,0,3,0,4.5 c0.3-0.2,0.6-0.5,0.9-0.7C23.8,95.3,24.1,95.6,24.5,95.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st16krh",
    d: "M23.7,28.7c-0.3,0.2-1,0.6-1.9,0.4c-0.9-0.2-1.5-0.9-1.8-1.3c-1.2-0.3-2.5-0.5-3.7-0.8 c0.7-1.8,1.8-5.1,2.2-9.7c0.3-3.2,0.2-6,0-7.9c1.3,0,2.6,0,3.9,0c1,1.9,2.1,3.8,3.1,5.8c0,2,0,4.8-0.6,8 C24.6,25.5,24.1,27.3,23.7,28.7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st17krh",
    d: "M38.4,9c4.3,0,8.5-0.1,12.8-0.1c0,2.2,0,4.3,0,6.5c0.4,0,0.8,0,1.2,0c0.1,0.7,0.3,1.6,0.5,2.5 c0.2,0.7,0.4,1.3,0.7,1.8c0.3,0.6,0.8,1.6,1.1,3.2c0.4,1.9,0.3,3.6,0.2,4.3c-5.4,0-10.8-0.1-16.2-0.1C38.6,21.1,38.5,15,38.4,9z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st17krh",
    d: "M16.6,9C12.4,9,8.1,8.9,3.8,8.9c0,2.2,0,4.3,0,6.5c-0.4,0-0.8,0-1.2,0c-0.1,0.7-0.3,1.6-0.5,2.5 c-0.2,0.7-0.4,1.3-0.7,1.8c-0.3,0.6-0.8,1.6-1.1,3.2c-0.4,1.9-0.3,3.6-0.2,4.3c5.4,0,10.8-0.1,16.2-0.1C16.4,21,16.5,15,16.6,9z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st18krh",
    d: "M35.9,7.8c0.8,0,1.6,0,2.5,0c0.1,0.7,0.3,1.4,0.4,2.1c0,5.7,0,11.5-0.1,17.2c-1.1-3-2.1-5.9-3.2-8.9 c0-3,0-6,0-9c0.1,0,0.2,0,0.3,0C35.9,8.7,35.9,8.2,35.9,7.8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st16krh",
    d: "M32.6,9c1.1,0,2.1,0,3.2,0c0,2.8,0,5.5,0,8.3c0.4,1.5,0.8,3.2,1.3,5c0.5,1.8,1.1,3.4,1.6,4.8 c-2.9-1-5.8-2-8.7-3c0-3.3,0.1-6.7,0.1-10c0.2-0.9,0.6-2,1.2-3.2C31.8,10,32.3,9.4,32.6,9z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st19krh",
    d: "M35.7,16.1c-0.5,0-1,0-1.5,0c0-0.9,0-1.8,0-2.7c0.5,0,1,0,1.4,0c0-0.3,0-0.6,0-0.9c-0.5,0-1.1,0-1.6,0 c-0.3,0.7-0.6,1.3-0.8,2c0,1,0,2,0,3c0.2,0.2,0.4,0.4,0.6,0.6c0.6,0,1.2,0,1.9,0C35.8,17.4,35.7,16.7,35.7,16.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st18krh",
    d: "M19.2,7.9c-0.8,0-1.6,0-2.5,0c-0.1,0.4-0.2,0.8-0.3,1.2c-0.1,6-0.1,12-0.2,18c1.1-2.9,2.2-5.8,3.3-8.8 c0-3,0-6,0-9c-0.1,0-0.2,0-0.3,0C19.2,8.8,19.2,8.3,19.2,7.9z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st20krh",
    d: "M18.3,72.6c6.3,0,12.5,0,18.8,0c0-16,0-32,0-48c0-0.2-0.2-2.1-1.2-2.9c-0.9-0.7-2-0.2-2.6,1.3 c-1.2,0-2.5,0-3.7,0c0,2.3,0,4.5,0,6.8c-1.7,1-3.3,2-5,3c0-3.2,0-6.3,0-9.5c-0.7,0-1.5,0-2.2,0c-0.1,0.9-0.8,5.3-1.3,5.2 c-0.6-0.1-0.7-5.4-0.7-6.2c-0.7,0-1.4,0-2.1,0C18.4,39,18.4,55.8,18.3,72.6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st15krh",
    d: "M23.9,60.8c0-1.7,0-3.4,0-5c-0.3,0.5-0.6,0.9-0.9,1.4c-0.3-0.3-0.6-0.6-1-0.9c0,1.5,0,3,0,4.5 c0.3-0.2,0.6-0.5,0.9-0.7C23.2,60.3,23.6,60.5,23.9,60.8z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st21krh",
    d: "M23.6,48.1c1.6-0.5,3.6-1.4,5.8-2.9c2.4-1.7,4.4-3.8,5.8-5.6c0-2.4,0-4.7,0-7.1c-0.1-0.5-0.3-1.5-0.8-2.2 c-0.8-1.2-2.1-1.2-3.2,0.1c-0.8,0.9-2,1.8-3.4,2.5c-0.9,0.4-1.8,0.6-2.5,0.7c-0.2,0.5-0.6,1.2-1.1,1.8c-0.7,0.8-1.4,1-1.8,1.1 c-0.5,0.6-1.1,1.5-1.7,2.8c-0.8,1.6-1.3,3.2-1.6,4.4c0,3,0,6,0,8.9c0.9-0.9,1.9-1.8,2.8-2.8c0-0.1-0.1-1.7,0.6-2.7 c0.8-1.2,1.7-0.6,1.8-0.6c0.3,0.2,0.6,0.3,0.9,0.5C24.7,47.2,24.2,47.6,23.6,48.1z"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8,
    y: 38,
    className: "st22krh",
    width: 2.5,
    height: 0.7
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8,
    y: 39.7,
    className: "st22krh",
    width: 2.5,
    height: 0.7
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8,
    y: 41.2,
    className: "st22krh",
    width: 1.8,
    height: 0.7
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st23krh",
    d: "M30.4,44.4c-0.1,0.1-0.2,0.2-0.3,0.2c0-4.4,0-8.9,0-13.3c0.1-0.1,0.2-0.2,0.3-0.3C30.4,35.5,30.4,40,30.4,44.4 z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st23krh",
    d: "M30.9,44c-0.1,0.1-0.2,0.2-0.3,0.2c0-4.4,0-8.9,0-13.3c0.1-0.1,0.2-0.2,0.3-0.3C30.9,35.1,30.9,39.5,30.9,44z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24krh",
    points: "32.9,33.4 32,34.2 31.2,33.4 31.2,31.6 32.1,30.8 32.9,31.6 "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st25krh",
    d: "M32.1,31.1c0.2-0.2,0.4-0.4,0.6-0.5c0.4-0.2,0.7-0.3,1-0.3c0.4,0.1,0.6,0.4,0.6,0.5c0.1,0.2,0.1,0.8,0.1,2 c0,0.1,0,0.1,0,0.1c0.1,0.6-0.1,1.2-0.4,1.4c-0.3,0.2-0.6,0-0.8-0.4c0-0.2,0-0.5-0.1-0.9c-0.1-0.4-0.3-0.6-0.4-0.7 C32.6,31.9,32.4,31.5,32.1,31.1z"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9,
    y: 34.3,
    className: "st26krh",
    width: 2.3,
    height: 0.2
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9,
    y: 34.5,
    className: "st20krh",
    width: 2.3,
    height: 0.2
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9,
    y: 34.7,
    className: "st26krh",
    width: 2.3,
    height: 0.2
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9,
    y: 35,
    className: "st20krh",
    width: 2.3,
    height: 0.2
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9,
    y: 35.2,
    className: "st26krh",
    width: 2.3,
    height: 0.2
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9,
    y: 35.4,
    className: "st20krh",
    width: 2.3,
    height: 0.2
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st27krh",
    cx: 34.7,
    cy: 37.4,
    rx: 0.3,
    ry: 2.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st28krh",
    d: "M26.6,37.2c1,0,1.9-0.1,2.9-0.1c0.1-0.2,0.3-0.7,0.3-1.5c0-0.8-0.1-1.7-0.3-2c-0.5-0.8-1.9-0.1-3.3,2.2 c-0.1,0.4-0.1,0.9,0.1,1.2C26.4,37.1,26.5,37.1,26.6,37.2z"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 37.5,
    className: "st29krh",
    width: 2.1,
    height: 7.4
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7,
    y: 38,
    className: "st29krh",
    width: 0.7,
    height: 8.6
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4,
    y: 37.3,
    className: "st29krh",
    width: 0.4,
    height: 4.5
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4,
    y: 41.3,
    className: "st29krh",
    width: 0.9,
    height: 0.5
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 39.6,
    className: "st29krh",
    width: 0.3,
    height: 2.2
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 22.9,
    y: 39.6,
    className: "st29krh",
    width: 0.4,
    height: 0.4
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 41.5,
    className: "st29krh",
    width: 0.3,
    height: 2.3
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 41.8,
    className: "st29krh",
    width: 0.9,
    height: 2.2
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 25.3,
    y: 42.8,
    className: "st29krh",
    width: 0.2,
    height: 1.2
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1,
    y: 39.4,
    className: "st29krh",
    width: 0.3,
    height: 1.5
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 26.2,
    y: 39.2,
    className: "st29krh",
    width: 0.5,
    height: 0.4
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 26.6,
    y: 39.4,
    className: "st29krh",
    width: 0.2,
    height: 4.6
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 37.1,
    className: "st29krh",
    width: 0.3,
    height: 7.7
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2,
    y: 37.7,
    className: "st29krh",
    width: 0.4,
    height: 3.2
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 38.5,
    className: "st29krh",
    width: 0.4,
    height: 2.4
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8,
    y: 39.1,
    className: "st29krh",
    width: 0.6,
    height: 1.9
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 40.7,
    className: "st29krh",
    width: 0.4,
    height: 1
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1,
    y: 48,
    className: "st29krh",
    width: 0.4,
    height: 1.5
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    y: 49,
    className: "st29krh",
    width: 0.8,
    height: 0.5
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8,
    y: 47.6,
    className: "st29krh",
    width: 0.2,
    height: 1.6
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 47.3,
    className: "st29krh",
    width: 0.3,
    height: 0.3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st30krh",
    d: "M24.2,91.3c-0.1-10.2-0.3-20.4-0.4-30.6c-0.3-0.2-0.6-0.4-0.9-0.6c-0.2,0.1-0.3,0.3-0.5,0.4 c0.1,10.3,0.3,20.7,0.4,31c0.3,0.2,0.5,0.5,0.8,0.7C23.8,91.9,24,91.6,24.2,91.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st30krh",
    d: "M25.3,46.8c-0.6,0.4-1.1,0.8-1.7,1.3c0.1,2.6,0.2,5.1,0.3,7.7c-0.3,0.5-0.6,0.9-0.9,1.4 c-0.3-0.3-0.6-0.6-1-0.9c0-2.2,0-4.4,0-6.6c0-0.3,0-1.8,0.6-2.8C23.3,45.8,24.4,45.7,25.3,46.8z"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 44.2,
    className: "st9krh",
    width: 1.5,
    height: 26.8
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 63.5,
    className: "st10krh",
    width: 1.5,
    height: 0.5
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 64.6,
    className: "st10krh",
    width: 1.5,
    height: 0.5
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 65.6,
    className: "st10krh",
    width: 1.5,
    height: 0.5
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 66.7,
    className: "st10krh",
    width: 1.5,
    height: 0.5
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 67.8,
    className: "st10krh",
    width: 1.5,
    height: 0.5
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 68.7,
    className: "st10krh",
    width: 1.5,
    height: 0.5
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 45.6,
    className: "st10krh",
    width: 1.5,
    height: 0.5
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 46.6,
    className: "st10krh",
    width: 1.5,
    height: 0.5
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 47.6,
    className: "st10krh",
    width: 1.5,
    height: 0.5
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 48.7,
    className: "st10krh",
    width: 1.5,
    height: 0.5
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 49.8,
    className: "st10krh",
    width: 1.5,
    height: 0.5
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 50.8,
    className: "st10krh",
    width: 1.5,
    height: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20krh",
    d: "M38.1,64.2c0-0.9-0.4-1.6-0.9-1.6v3.2C37.7,65.8,38.1,65.1,38.1,64.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20krh",
    d: "M17.4,64.8c0,0.9,0.4,1.6,0.9,1.6v-3.2C17.8,63.2,17.4,63.9,17.4,64.8z"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st17krh",
    d: "M24.7,14c2,0,3.9,0,5.9,0c0,3.1,0,6.2,0,9.3c-0.3,0-0.7,0-1,0c0,2.2,0,4.4,0,6.6c-1.7,1-3.3,1.9-5,2.9 C24.7,26.5,24.7,20.2,24.7,14z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st23krh",
    d: "M24.9,6.4c-0.1,2.5-0.3,5.1-0.4,7.6c-1-1.7-2-3.4-3-5.1c0.2-0.4,0.4-1,0.8-1.5C23.4,6.2,24.6,6.4,24.9,6.4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st23krh",
    d: "M30.2,6.3c0.1,2.5,0.2,5.1,0.3,7.6c0.9-1.7,1.9-3.4,2.8-5.1c-0.1-0.4-0.4-1-0.8-1.5 C31.6,6.1,30.5,6.2,30.2,6.3z"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3,
    y: 6.5,
    className: "st31krh",
    width: 6.8,
    height: 8.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st32krh",
    d: "M21.8,8.4c0-2.2,0-4.4,0-6.7c1.5-0.9,3.9-2.1,7-1.7C30.5,0.3,32,1,33.1,1.7c0,2.2,0,4.3,0,6.5 c-1.5-0.7-3.6-1.4-6.1-1.3C24.8,7.1,23.1,7.7,21.8,8.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyloRenHilt);
export default __webpack_public_path__ + "static/media/kylo-ren-hilt.13882eec.svg";
export { ForwardRef as ReactComponent };